// src/hooks/useTenantModules.js
import { useEffect, useMemo, useState } from 'react'
import { apiFetch } from '../api.js'
import { MODULES, MODULES_BY_KEY } from '../modules/registry.js'

export function useTenantModules() {
  const [loading, setLoading] = useState(false)
  const [modules, setModules] = useState(() => {
    const map = {}
    for (const m of MODULES) {
      map[m.key] = { ...m, enabled: true, config: {} }
    }
    return map
  })

  const load = () => {
    setLoading(true)
    apiFetch('/api/settings/modules')
      .then((res) => {
        const map = {}
        for (const m of MODULES) {
          map[m.key] = { ...m, enabled: true, config: {} }
        }
        for (const m of res?.modules || []) {
          if (!m?.key) continue
          map[m.key] = {
            ...(MODULES_BY_KEY[m.key] || { key: m.key, label: m.key }),
            enabled: m.enabled !== false,
            config: m.config || {},
          }
        }
        setModules(map)
      })
      .catch(() => {})
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    let alive = true
    if (alive) load()
    const handler = () => load()
    window.addEventListener('tenant-modules-updated', handler)
    return () => {
      alive = false
      window.removeEventListener('tenant-modules-updated', handler)
    }
  }, [])

  const isModuleEnabled = useMemo(() => (key) => {
    if (!key) return true
    if (!modules[key]) return true
    return modules[key].enabled !== false
  }, [modules])

  return { modules, loading, isModuleEnabled, setModules }
}

export default useTenantModules
